import React, { ComponentType, LazyExoticComponent, Suspense } from 'react';

// project imports
import Loader from './Loader';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable = <P extends Record<string, unknown>>(
  Component: LazyExoticComponent<ComponentType<P>> | ComponentType<P>
): React.FC<P> => {
  const Wrapped: React.FC<P> = (props) => (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );
  return Wrapped;
};

export default Loadable;
